import type { RootState } from '../../reducers';

const selectReferralCode = (state: RootState) => state.referral.code;

export default selectReferralCode;
